<app-aside-nav></app-aside-nav>
<app-right-aside-nav></app-right-aside-nav>
<app-right-aside-nav-2></app-right-aside-nav-2>
<app-right-aside-nav-nested></app-right-aside-nav-nested>
<div class="m-grid__item m-grid__item--fluid m-wrapper" style="height: 100%;">
	<router-outlet></router-outlet>
</div>
